import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/masterdata-api/mail/approve/page', params)

// 删除
export const removeItem = id =>
  request.get(`/masterdata-api/mail/approve/delete/${id}`)

// 新增或更新
export const updateOrAdd = params =>
  request.post('/masterdata-api/mail/approve/add', params)

export const getOptionList = params =>
  request.post('/masterdata-api/valuelist/getValueList', params)
